import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DuePaymentsComponent } from './due-payments/due-payments.component';
import { PaymentInstallmentComponent } from './payment-installment/payment-installment.component';
import { PaymentInstallmentListComponent } from './payment-installment-list/payment-installment-list.component';
import { PaymentInstallmentDetailComponent } from './payment-installment-detail/payment-installment-detail.component';
import { OffsetMasterComponent } from './payment-installment-detail/offset-master/offset-master.component';
import { OffsetDetailComponent } from './payment-installment-detail/offset-master/offset-detail/offset-detail.component';
import { DueOffsetDetailComponent } from './due-payments/due-offset-detail/due-offset-detail.component';

const routes: Routes = [
  { path: 'due-payments', component: DuePaymentsComponent, data: { title: 'Due Payments' } },
  { path: 'payment-installments', component: PaymentInstallmentComponent, data: { title: 'Payment Installments' } },
  { path: 'payment-installment-list', component: PaymentInstallmentListComponent, data: { title: 'Payment Installments List' } },
  { path: 'payment-detail', component: PaymentInstallmentDetailComponent, data: { title: 'Payment Installments Detail' } },
  { path: 'offset-payments', component: OffsetMasterComponent, data: { title: 'Offset Payments' } },
  { path: 'offset-payment-detail', component: OffsetDetailComponent, data: { title: 'Offset Payment Detail' } },
  { path: 'due-offset-detail', component: DueOffsetDetailComponent, data: { title: 'Due Offset Detail' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentsRoutingModule { }
